import DB from '../../DAL/DB'
import {store} from '../reducer'

export default function getFormFields(form) {
  if (!form || !form.id) return

  const sections = new DB.FormSection(form.id)
  const actions = new DB.FormAction(form.id)
  const sectionIds = form.order
  const unsubscribes = []

  // Accumulate section metadata and fields locally before dispatching
  const sectionData = {}  // { [sId]: { id, title, order } }
  const fieldData = {}    // { [sId]: { [fieldId]: field } }
  let initialDispatchDone = false

  function tryDispatchAll() {
    if (initialDispatchDone) return
    const allReady = sectionIds.every(id => sectionData[id] && fieldData[id])
    if (!allReady) return

    initialDispatchDone = true
    const combined = {}
    for (const id of sectionIds) {
      combined[id] = { ...sectionData[id], fields: fieldData[id] }
    }
    store.dispatch({ type: 'updateAllSections', value: combined })
  }

  const actionData = actions.subscribe(null, null, ({data, ok}) => {
    if (ok) {
      store.dispatch({type: 'actionData', value: data})
    }
  })

  for (let sId of sectionIds) {
    const sUnsubscribe = sections.subscribe(sId, null, ({data, ok}) => {
      const [{id, title, order}] = data || [{}]
      if (ok) {
        sectionData[sId] = {id, title, order}
        if (initialDispatchDone) {
          store.dispatch({type: 'section', id: sId, value: {id, title, order}})
        } else {
          tryDispatchAll()
        }
      }
    })

    const fields = new DB.FormField(form.id, sId)
    const fUnsubscribe = fields.subscribe(null, null, ({data, ok}) => {
      if (ok) {
        const ff = {}
        for (let field of data) {
          ff[field.id] = field
        }
        fieldData[sId] = ff
        if (initialDispatchDone) {
          store.dispatch({type: 'sectionField', field: 'fields', id: sId, value: ff})
        } else {
          tryDispatchAll()
        }
      }
    })

    unsubscribes.push([sUnsubscribe, fUnsubscribe, actionData])
  }

  return () => {
    unsubscribes.map(([s, f, a]) => {
      s()
      f()
      a()
    })
  }
}
